import { useContext, useState, useEffect, useMemo } from 'react';
import { ThemeContext } from '../styled';
const useIsMobile = () => {
    const theme = useContext(ThemeContext);
    const mediaQueryList = useMemo(() => window.matchMedia(`(max-width: ${theme.breakpoints.mobile}px)`), [theme.breakpoints.mobile]);
    const [isMobile, setIsMobile] = useState(() => mediaQueryList.matches);
    useEffect(() => {
        const cb = ({ matches }) => {
            setIsMobile(matches);
        };
        mediaQueryList.addListener(cb);
        return () => mediaQueryList.removeListener(cb);
    }, [mediaQueryList]);
    return isMobile;
};
export default useIsMobile;
//# sourceMappingURL=useIsMobile.js.map